module.exports = "<button class=\"btn btn-default\" (click)=\"onDeleteFile(file)\">\n    <i class=\"fa fa-trash-o\" *ngIf=\"snEmpty\"></i>\n    <i class=\"fi fa fa-trash-o\" *ngIf=\"!snEmpty\"></i>\n    {{ text }}\n</button>\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/jobs/common/btn-delete-file/btn-delete-file.html
// module id = ./web/modern/components/jobs/common/btn-delete-file/btn-delete-file.html
// module chunks = 0